import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getMarketplace from "../global-config/get-marketplace";
export var SUPPORTED_BUY_MARKETPLACES = new Set(['US', 'CN', 'HK', 'JP', 'KR', 'MX', 'ASTLA', 'CA', 'CAN', 'AT', 'GB', 'DK', 'FI', 'FR', 'DE', 'IE', 'IT', 'LU', 'SE', 'ES', 'NL', 'BE', 'CZ', 'GR', 'HU', 'PL', 'PT', 'SI', 'TW', 'SG', 'MY', 'TH', 'VN', 'ID', 'PH', 'CH', 'NO', 'BG', 'TR', 'IL', 'SK', 'HR', 'RO', 'ZA']);
export var isBuyMarketplaceSupported = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var marketplace;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return getMarketplace();
        case 1:
          marketplace = _context.sent;
          return _context.abrupt("return", Boolean(marketplace) && SUPPORTED_BUY_MARKETPLACES.has(marketplace));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isBuyMarketplaceSupported() {
    return _ref.apply(this, arguments);
  };
}();